import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import { BeatLoader } from 'react-spinners';

const propTypes = {
    children: PropTypes.node.isRequired,
    active: PropTypes.bool,
};
const defaultProps = { active: false };

function LoadingPaper({ children, active }) {
    return (
        <LoadingOverlay
            active={active}
            spinner={<BeatLoader color="white" />}
        >
            <Box height="100vh">
                {children}
            </Box>
        </LoadingOverlay>
    );
}

LoadingPaper.propTypes = propTypes;
LoadingPaper.defaultProps = defaultProps;

export default LoadingPaper;
